import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import BulkUploadFile from "../../components/BulkUploadFile";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Drivers will be opted in Gigs from next day onwards.",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const GigsBulkOptIn = ({ getGigsBulkOptInUrl }) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="driverSlotsGigsOptInModal"
      uploadUrl="/driver-shift/slot/bulk-driver-gigs-opt-in/ack"
      sampleURL="/sample/bulk_driver_gigs_opt_in.csv"
      id="driverSlotsGigsOptInModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs Opt In"
      getUploadUrl={getGigsBulkOptInUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getGigsBulkOptInUrl: bindActionCreators(
      SlotsPropertiesActions.getGigsBulkOptInUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(GigsBulkOptIn);
